module.exports = __webpack_public_path__ + "static/media/d12kz.83464027.pdf";